import type {SupabaseClient} from '@supabase/supabase-js';
import {errorMessage} from './errors';

export async function renewSavedSession(auth:SupabaseClient['auth']) {
  const previous=await auth.getSession();if(previous.error)throw previous.error;
  if(!previous.data.session)throw new Error('No saved login. Use a team invitation for this browser’s first connection.');
  const refreshed=await auth.refreshSession();
  if(refreshed.error)throw new Error(`Could not renew the saved login: ${errorMessage(refreshed.error)}. Keep this browser’s saved data while we recover access.`);
  if(!refreshed.data.session||refreshed.data.session.user.id!==previous.data.session.user.id)throw new Error('The saved login changed during renewal. Reload Hope Mixer before connecting.');
  return refreshed.data.session;
}

export function expiredSession(error:unknown):boolean {
  if(!error||typeof error!=='object')return false;
  const context='context'in error?error.context:undefined;
  return context instanceof Response&&context.status===401||/\bJWT\b.*\bexpired\b|\bsession expired\b/i.test(errorMessage(error));
}

/** Retry only rejected authentication; these requests have not reached mutations. */
export async function retryExpiredSession<T extends {error:unknown}>(operation:()=>PromiseLike<T>,renew:()=>Promise<unknown>):Promise<T>{
  const result=await operation();
  if(!expiredSession(result.error))return result;
  await renew();return await operation();
}
